import React, { Component } from "react";
import "./App.css";
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import "primereact/resources/primereact.min.css"; //core css
import "primeicons/primeicons.css"; //icons
import "./styles/buttons.css";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";

import { Helmet } from "react-helmet";
import Server from "./components/Server.js";
import { Routes, Route, HashRouter } from "react-router-dom";
import { Provider } from "react-redux";
import reducer from "./reducer.js";
import { createStore } from "redux";
import Blogs from "./components/Blogs.js";
import ScrollToTop from "./components/ScrollToTop.js";
import TurnRating from './components/TurnRating'
import Login from "./components/Login.js";
import Home from "./components/Home.js";
import LandingPage from "./components/LandingPage.js";
import Footer from "./components/Footer";
import Admin from "./components/Admin.js";
import Turnover from "./components/Turnover.js";
import Support from "./components/Supprot.js";
import QrCode from "./components/QrCode.js";
import Buy from "./components/Buy.js";
import ShopList from "./components/ShopList.js";
import Shop from "./components/Shop.js";
import Charge from "./components/Charge.js";
import Internet from "./components/Internet.js";
import Bill from "./components/Bill.js";
import Form from "./components/Form.js";
import Poll from "./components/Poll.js";

import CreditPrice from "./components/CreditPrice.js";
import Travel from "./components/travel/index.js";
import TravelSearch from "./components/travel/Search.js";

import Ticket from "./components/Ticket.js";
import Ticketing from "./components/Ticketing.js";

import Reserve from "./components/travel/Reserve.js";
import ReserveList from "./components/travel/ReserveList.js";
import Iframes from "./components/raymand/Iframes.js";
import Services from "./components/raymand/Services.js";
import Cheque from "./components/raymand/Cheque.js";
import Transfer from "./components/raymand/Transfer.js";
import Club from "./components/raymand/Club.js";
import Gardesh from "./components/raymand/Gardesh.js";
import Hesab from "./components/raymand/Hesab.js";
import Vam from "./components/raymand/Vam.js";
import VamPoint from "./components/raymand/VamPoint.js";
import reqVam from "./components/raymand/reqVam.js";
import New from "./components/raymand/New.js";
import OfflineTransfer from "./components/raymand/OfflineTransfer.js";
import ChangePass from "./components/raymand/ChangePass.js";
import SetDeposit from "./components/raymand/SetDeposit.js";
import TransferLink from "./components/raymand/TransferLink.js";


import MainBox from "./components/onlineShop/MainBox.js";
import Products from "./components/onlineShop/Products.js";
import CatList from "./components/onlineShop/CatList.js";
import Cart from "./components/onlineShop/Cart.js";
import Category from "./components/onlineShop/Category.js";
import Tag from "./components/onlineShop/Tag.js";

import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import { configureStore } from "@reduxjs/toolkit";
import Axios from "axios";

Axios.defaults.withCredentials = true;

const firebaseConfig = new Server().getFirebaseConfig();
let app, messaging;
if (firebaseConfig) {
  app = initializeApp(firebaseConfig);
  messaging = getMessaging(app);
}

class App extends Component {
  //store = createStore(reducer);
  store = configureStore({ reducer: reducer });

  constructor(props) {
    super(props);
    this.Server = new Server();
    this.state = {
      ChatId: "",
      absoluteUrl: this.Server.getAbsoluteUrl(),
      System: this.Server.getSystem(),
      noForceLogin: false,
      theme: 1,
      appDataRecieved: false,
    };
    this.getAppData = this.getAppData.bind(this);
  }
  componentDidMount() {
    this.getAppData();
  }
  setNotificationToken() {
    let that = this;
    getToken(messaging, {
      vapidKey:
        "BGY4PYqXBZnU6pQuU3X30Qx1NqptOL89EcnUHNtgbA7fyZK99i8g05YNEsJhZiZIZ2wZSH5iba_msKNsxSqhOcc",
    })
      .then((currentToken) => {
        if (currentToken) {
          let SCallBack = function (response) {};
          let ECallBack = function (error) {};
          that.Server.send(
            "AdminApi/setNotificationToken",
            { token: currentToken },
            SCallBack,
            ECallBack
          );
          // Send the token to your server and update the UI if necessary
          // ...
        } else {
          // Show permission request UI
          console.log(
            "No registration token available. Request permission to generate one."
          );

          // ...
        }
      })
      .catch((err) => {
        console.log("An error occurred while retrieving token. ", err);

        // ...
      });
  }
  async getAppData() {
    let that = this;
    this.setState({
      loading: true,
      connectionError: false,
    });
    let SCallBack = function (response) {
      if (response.data.result[0]) {
        import(`./styles/${response.data.result[0].lName}/index.css`);
        that.setState({
          STitle: response.data.result[0].fName,
          noForceLogin: response.data.result[0].noForceLogin,
          theme: response.data.result[0].theme || 1,
          appDataRecieved: true,
          loading: false,
        });
      }
      //that.setNotificationToken();
    };
    let ECallBack = function (error) {
      that.setState({
        loading: false,
        connectionError: true,
      });
    };
    const condition = this.state.System
      ? { condition: { code: this.state.System.code } }
      : { condition: { code: 1000 } };
    this.Server.send("MainApi/getAppData", condition, SCallBack, ECallBack);
  }
  render() {
    return (
      <div style={{ height: "100%" }}>
        {this.state.connectionError && (
          <p style={{ padding: 10, direction: "rtl", marginTop: 150 }}>
            <div>
              <p style={{ textAlign: "center" }}>
                <img src="/connection.png" />
              </p>
              <h3 style={{ color: "red", textAlign: "center" }}>
                ارتباط با سرور برقرار نیست
              </h3>
              <ul>
                <li>اتصال اینترنت خود را بررسی کنید</li>
                <li>نرم افزار ضد فیلتر خود را خاموش کنید</li>
                <li>
                  <a href="tel:+09133600091">
                    <span>در صورتی که مشکل باقیست جهت تماس با مسئول فنی سایت  کلیک کنید</span>
                    <div style={{textAlign: 'center'}}>09133600091 (مهندس کارگر)</div>
                  </a>
                </li>
              </ul>
              <p style={{ textAlign: "center" }}>
                <Button
                  className="iranyekanwebmedium  p-button-lg p-button-danger"
                  onClick={() => {
                    this.getAppData();
                  }}
                >
                  <span
                    className="iranyekanwebmedium"
                    style={{ width: "100%" }}
                  >
                    بررسی مجدد
                  </span>
                </Button>
              </p>
            </div>
          </p>
        )}
        {this.state.loading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <ProgressSpinner
              style={{ width: "50px", height: "50px" }}
              strokeWidth="2"
              fill="var(--surface-ground)"
              animationDuration=".5s"
            />
          </div>
        )}
        <Provider store={this.store} style={{ height: "100%" }}>
          <HashRouter>
            <div style={{ height: "100%" }}>
              <Helmet>
                <title>{this.state.STitle}</title>
                <link rel="shortcut icon" href="/favicon.png"></link>
                <meta name="theme-color" content="#20ad31" />
                <meta name="description" content={this.state.Tags} />
                <meta name="keywords" content={this.state.Tags} />
              </Helmet>
              <ScrollToTop />
              {this.state.appDataRecieved && (
                <Routes>
                  <Route
                    path="/"
                    element={
                      this.state.theme == 2 ? (
                        <LandingPage />
                      ) : this.state.noForceLogin ? (
                        <Home />
                      ) : (
                        <Login />
                      )
                    }
                    exact
                  />
                  <Route path="/TurnRating" element={<TurnRating />} />
                  <Route path="/LandingPage" element={<LandingPage />} />
                  <Route path="/Home" element={<Home />} />
                  <Route path="/Footer" element={<Footer />} />
                  <Route path="/Blogs" element={<Blogs />} />
                  <Route path="/Admin" element={<Admin />} />
                  <Route path="/Turnover" element={<Turnover />} />
                  <Route path="/Support" element={<Support />} />
                  <Route path="/QrCode" element={<QrCode />} />
                  <Route path="/Buy" element={<Buy />} />
                  <Route path="/ShopList" element={<ShopList />} />
                  <Route path="/Shop" element={<Shop />} />
                  <Route path="/Reserve" element={<Reserve />} />
                  <Route path="/ReserveList" element={<ReserveList />} />
                  <Route path="/Iframes" element={<Iframes />} />
                  <Route path="/Services" element={<Services />} />
                  <Route path="/Cheque" element={<Cheque />} />
                  <Route path="/Transfer" element={<Transfer />} />
                  <Route path="/Travel" element={<Travel />} />
                  <Route path="/TravelSearch" element={<TravelSearch />} />
                  <Route path="/Ticket" element={<Ticket />} />
                  <Route path="/Ticketing" element={<Ticketing />} />
                  <Route path="/Club" element={<Club />} />
                  <Route path="/Gardesh" element={<Gardesh />} />
                  <Route path="/Hesab" element={<Hesab />} />
                  <Route path="/Vam" element={<Vam />} />
                  <Route path="/VamPoint" element={<VamPoint />} />
                  <Route path="/reqVam" element={<reqVam />} />
                  <Route path="/New" element={<New />} />
                  <Route path="/TransferLink" element={<TransferLink />} />
                  <Route
                    path="/OfflineTransfer"
                    element={<OfflineTransfer />}
                  />
                  <Route path="/ChangePass" element={<ChangePass />} />
                  <Route path="/Bill" element={<Bill />} />
                  <Route path="/Form" element={<Form />} />
                  <Route path="/CreditPrice" element={<CreditPrice />} />
                  <Route path="/SetDeposit" element={<SetDeposit />} />
                  <Route path="/Charge" element={<Charge />} />
                  <Route path="/Internet" element={<Internet />} />
                  <Route path="/MainBox" element={<MainBox />} />
                  <Route path="/Products" element={<Products />} />
                  <Route path="/Cart" element={<Cart />} />
                  <Route path="/CatList" element={<CatList />} />
                  <Route path="/Category" element={<Category />} />
                  <Route path="/Tag" element={<Tag />} />
                  <Route path="/Poll" element={<Poll />} />
                 
                </Routes>
              )}
            </div>
          </HashRouter>
        </Provider>
      </div>
    );
  }
}

export default App;
